export default __webpack_public_path__ + "static/media/organizacja-wydarzen-przedslubnych.83b945f0.md";